// src/pages/admin/mixedCompanyAssignJobs/helpers.js — pure helpers for building blank stop
// rows and resolving company/driver/truck/site display labels, used by MixedCompanyAssignJobs.
// No React state; every function is a function of its arguments only.

export const createTempId = () =>
  `stop_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

export const emptyDefaultStop = () => ({
  address: "",
  eta: "",
  description: "",
  poNumber: "",
  epaWasteTracker: "",
  siteContact: "",
  sitePhone: "",
  siteEmail: "",
  docketMode: "sign",
  fixed: false,
  _tempId: createTempId(),
});

export const emptyGreenspaceStop = () => ({
  address: "",
  eta: "",
  poNumber: "",
  epaWasteTracker: "",
  customerId: "",
  siteId: "",
  jobTypeId: "",
  siteLabel: "",
  siteContact: "",
  sitePhone: "",
  siteEmail: "",
  description: "",
  docketMode: "sign",
  fixed: false,
  _tempId: createTempId(),
});

export function toAbbrevCode(name = "") {
  const n = String(name).toLowerCase();
  if (n.includes("empty")) return "EMP";
  if (n.includes("pick")) return "PK";
  return "DV";
}

export function getCompanyUiVariant(company) {
  if (!company) return "default";
  const v = String(company.uiVariant || "").toLowerCase();
  if (v === "greenspace") return "greenspace";
  const nm = String(company.name || "").toLowerCase();
  if (nm.includes("greenspace")) return "greenspace";
  return "default";
}

export function makeEmptyStopForCompany(company) {
  return getCompanyUiVariant(company) === "greenspace"
    ? emptyGreenspaceStop()
    : emptyDefaultStop();
}

export function getTruckDisplayLabel(truck) {
  if (!truck) return "";
  const rego = String(truck.rego || "").trim();
  const loadType = String(truck.loadType || "").trim();
  if (rego && loadType) return `${rego} • ${loadType}`;
  return rego || loadType || "";
}

export function getDriverDisplayLabel(driver) {
  if (!driver) return "";
  return driver.email || driver.displayName || driver.name || driver.uid || "Driver";
}

export function getFirstNonEmpty(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}

export function getSiteContactName(site = {}) {
  return getFirstNonEmpty(
    site.bookingContactName,
    site.contactName,
    site.bookingContact?.name,
    site.bookingContactDetails?.name,
    site.booking?.name,
  );
}

export function getSiteContactPhone(site = {}) {
  return getFirstNonEmpty(
    site.bookingContactPhone,
    site.contactPhone,
    site.bookingContact?.phone,
    site.bookingContactDetails?.phone,
    site.booking?.phone,
  );
}

export function getSiteContactEmail(site = {}) {
  return getFirstNonEmpty(
    site.bookingContactEmail,
    site.contactEmail,
    site.bookingContact?.email,
    site.bookingContactDetails?.email,
    site.booking?.email,
  );
}
